<template>
  <Flex :direction="$screen === 's' ? 'column' : 'row'">
    <BaseButton
      color="inverted"
      @click="$emit('close')"
      v-test="'resource-close'"
    >
      {{ $t('global.actions.close') }}
    </BaseButton>
    <BaseButton
      :loading="isLoading"
      submitForm
      v-test="'resource-submit'"
    >
      {{ $t('global.actions.save') }}
    </BaseButton>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    resource: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
    },
  },
  emits: ['close'],
});
</script>
